import * as React from "react"

import Breadcrumb from "./Breadcrumb"

interface Props {
    sortedBreadcrumbs: ResourceHeader.BreadcrumbInfo[]
}

export const FullStructure = ({ sortedBreadcrumbs }: Props): JSX.Element => (
    <>
        {sortedBreadcrumbs.map((br) => (
            <Breadcrumb key={br.uuid} breadcrumbInfo={br} />
        ))}
    </>
)

export default FullStructure
